//----------------------------------------------------------------------------------------------------------------------
import {findTexture} from "./pixi-extensions";
import {UIBase} from "./UIBase";

export class UISprite extends UIBase {
    constructor(texture) {
        super(findTexture(texture));
        this.anchor.set(0.5);
    }

    setImage(texture) {
        this.texture = findTexture(texture);
    }

    fitRect(rect, fill = false) {
        let values = [
            rect.width / this.texture.width,
            rect.height / this.texture.height
        ];
        this.scale.set(fill ? Math.max(...values) : Math.min(...values));
        this.position.set(
            rect.x + rect.width * this.anchor.x,
            rect.y + rect.height * this.anchor.y,
        );
    }
}
